import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import SalesTeam from "../../../classes/SalesTeam";

export default {
  routes: [
    {
      name: "sales-teams",
      path: "sales-teams/:filter?",
      meta: {
        auth: () => SalesTeam.canBeViewedBy(store.state.main.user),
        icon: "sales_team",
        title: i18n.global.t("Sales Teams"),
        crumbs: ["admin"],
        color: "admin",
      },
      component: () => import("pages/admin/SalesTeams"),
    },
  ],

  dialogs: [
    {
      name: "sales-team-new",
      path: "/admin/sales-teams/new",
      meta: {
        auth: () => SalesTeam.canBeCreatedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/SalesTeamEdit"),
    },
    {
      name: "sales-team-edit",
      path: "/admin/sales-teams/:teamID/edit",
      meta: {
        auth: () => SalesTeam.canBeEditedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/SalesTeamEdit"),
    },
  ],
};
